import React, { useState } from "react";
import "./Products.css";
import ImageWithSkeleton from "./ImageWithSkeleton";

// Rich dataset of products with assigned categories and brand mappings
const products = [
  // IIL Products
  {
    id: 1,
    name: "Metacil",
    brand: "IIL India",
    category: "Insecticide",
    image: "/assets/iil/1.jpg"
  },
  {
    id: 2,
    name: "AgroSpred Max",
    brand: "IIL India",
    category: "Silicone Spreader",
    image: "/assets/iil/2.jpg"
  },
  {
    id: 3,
    name: "Bheema",
    brand: "IIL India",
    category: "Insecticide",
    image: "/assets/iil/3.png"
  },
  {
    id: 4,
    name: "Lethal 20 EC",
    brand: "IIL India",
    category: "Insecticide",
    image: "/assets/iil/4.jpg"
  },
  {
    id: 5,
    name: "Hijack Super",
    brand: "IIL India",
    category: "Herbicide",
    image: "/assets/iil/5.jpg"
  },
  {
    id: 6,
    name: "Hakama",
    brand: "IIL India",
    category: "Herbicide",
    image: "/assets/iil/6.png"
  },
  {
    id: 7,
    name: "Milstim",
    brand: "IIL India",
    category: "Organic Manure",
    image: "/assets/iil/7.jpg"
  },
  {
    id: 8,
    name: "Pendamil Super",
    brand: "IIL India",
    category: "Herbicide",
    image: "/assets/iil/8.jpg"
  },
  {
    id: 9,
    name: "Sargent",
    brand: "IIL India",
    category: "Insecticide",
    image: "/assets/iil/9.jpg"
  },
  {
    id: 10,
    name: "Hercules",
    brand: "IIL India",
    category: "Insecticide",
    image: "/assets/iil/10.jpg"
  },
  {
    id: 11,
    name: "Aikido",
    brand: "IIL India",
    category: "Insecticide",
    image: "/assets/iil/11.png"
  },
  {
    id: 12,
    name: "Sofia",
    brand: "IIL India",
    category: "Fungicide",
    image: "/assets/iil/12.jpeg"
  },
  {
    id: 13,
    name: "Encounter",
    brand: "IIL India",
    category: "Insecticide",
    image: "/assets/iil/13.png"
  },
  {
    id: 14,
    name: "Xplode",
    brand: "IIL India",
    category: "Insecticide",
    image: "/assets/iil/14.jpg"
  },
  {
    id: 15,
    name: "Oxim",
    brand: "IIL India",
    category: "Herbicide",
    image: "/assets/iil/15.jpg"
  },
  {
    id: 16,
    name: "Hachiman",
    brand: "IIL India",
    category: "Herbicide",
    image: "/assets/iil/16.webp"
  },
  // Heranba Products
  {
    id: 17,
    name: "Roxyfin",
    brand: "Heranba",
    category: "Insecticide",
    image: "/assets/heranba/1.jpg"
  },
  {
    id: 18,
    name: "Anika",
    brand: "Heranba",
    category: "Insecticide",
    image: "/assets/heranba/2.jpg"
  },
  {
    id: 19,
    name: "Prompt Plus",
    brand: "Heranba",
    category: "Insecticide",
    image: "/assets/heranba/3.jpg"
  },
  {
    id: 20,
    name: "Astron",
    brand: "Heranba",
    category: "Fungicide",
    image: "/assets/heranba/4.jpg"
  },
  {
    id: 21,
    name: "Bupro Star",
    brand: "Heranba",
    category: "Insecticide",
    image: "/assets/heranba/5.jpg"
  },
  {
    id: 22,
    name: "Pendant",
    brand: "Heranba",
    category: "Herbicide",
    image: "/assets/heranba/6.jpg"
  },
  {
    id: 23,
    name: "Tebu",
    brand: "Heranba",
    category: "Fungicide",
    image: "/assets/heranba/7.jpg"
  },
  {
    id: 24,
    name: "Heragor",
    brand: "Heranba",
    category: "Insecticide",
    image: "/assets/heranba/8.jpg"
  },
  {
    id: 25,
    name: "Delta Super",
    brand: "Heranba",
    category: "Insecticide",
    image: "/assets/heranba/9.jpg"
  },
  {
    id: 26,
    name: "Mantra G",
    brand: "Heranba",
    category: "Insecticide",
    image: "/assets/heranba/10.jpg"
  },
  {
    id: 27,
    name: "Delta Jet",
    brand: "Heranba",
    category: "Insecticide",
    image: "/assets/heranba/11.jpg"
  },
  // Sumitomo Products
  {
    id: 28,
    name: "ProGibb easy",
    brand: "Sumitomo",
    category: "Plant Growth Regulator",
    image: "/assets/sumitomo/1.png"
  },
  {
    id: 29,
    name: "SumiPleo",
    brand: "Sumitomo",
    category: "Insecticide",
    image: "/assets/sumitomo/2.png"
  },
  {
    id: 30,
    name: "Laatu",
    brand: "Sumitomo",
    category: "Organic Plant Food",
    image: "/assets/sumitomo/3.png"
  },
  {
    id: 31,
    name: "Hoshi",
    brand: "Sumitomo",
    category: "Gibberellic Acid",
    image: "/assets/sumitomo/4.png"
  },
  {
    id: 32,
    name: "Kitoshi",
    brand: "Sumitomo",
    category: "Fungicide",
    image: "/assets/sumitomo/5.png"
  },
  {
    id: 33,
    name: "Sumiprempt",
    brand: "Sumitomo",
    category: "Insecticide",
    image: "/assets/sumitomo/6.png"
  },
  {
    id: 34,
    name: "Sumi Max",
    brand: "Sumitomo",
    category: "Herbicide",
    image: "/assets/sumitomo/7.png"
  },
  {
    id: 35,
    name: "Dantotsu",
    brand: "Sumitomo",
    category: "Insecticide",
    image: "/assets/sumitomo/8.png"
  },
  {
    id: 36,
    name: "Jika",
    brand: "Sumitomo",
    category: "Plant Growth Regulator",
    image: "/assets/sumitomo/9.png"
  },
  {
    id: 37,
    name: "Danitol",
    brand: "Sumitomo",
    category: "Insecticide",
    image: "/assets/sumitomo/10.png"
  },
  {
    id: 38,
    name: "Celphos",
    brand: "Sumitomo",
    category: "Fumigant",
    image: "/assets/sumitomo/12.jpg"
  }
];

function Products() {
  const [filter, setFilter] = useState("All");
  const [selectedImage, setSelectedImage] = useState(null);

  const tabs = [
    { id: "All", label: "All Products" },
    { id: "Heranba", label: "Heranba" },
    { id: "IIL India", label: "IIL India" },
    { id: "Sumitomo", label: "Sumitomo" },
  ];

  // Filter products based on selected company brand tab
  const filteredProducts = products.filter((product) => {
    if (filter === "All") return true;
    return product.brand === filter;
  });

  return (
    <div className="products-page-container">
      {/* Page Hero Banner */}
      <div className="page-hero">
        <div className="page-hero-content">
          <h1 className="page-title">Our Products</h1>
          <p className="page-subtitle">Authorized Distributors of IIL, Heranba, Sumitomo and More...</p>
        </div>
      </div>

      <section className="products-section">
        <div className="products-container">
          <span className="section-tag">Filter & Browse</span>
          <h2 className="section-title">Products Catalog</h2>
          <p className="section-subtitle">Browse through our authorized catalog of high-quality products</p>

          {/* Filter Tabs */}
          <div className="filter-tabs">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                className={`tab ${filter === tab.id ? "active" : ""}`}
                onClick={() => setFilter(tab.id)}
              >
                {tab.label}
              </button>
            ))}
          </div>

          {/* Products Grid */}
          <div className="products-grid">
            {filteredProducts.map((product) => (
              <div 
                key={product.id} 
                className="prod-card"
                onClick={() => setSelectedImage(product.image)}
              >
                <div className="prod-img">
                  <ImageWithSkeleton
                    src={product.image}
                    alt={product.name}
                    className="product-card-img"
                    fallbackIcon="📦 Photo"
                    fallbackClassName="image-fallback"
                  />
                </div>
                <div className="prod-info">
                  <div className="prod-name">{product.name}</div>
                  <div className="prod-brand">{product.brand} · {product.category}</div>
                </div>
              </div>
            ))}
          </div>

          {filteredProducts.length === 0 && (
            <div className="no-products">
              <p>No products found in this category.</p>
            </div>
          )}
        </div>
      </section>

      {/* Modal for enlarged image */}
      {selectedImage && (
        <div className="image-modal" onClick={() => setSelectedImage(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={() => setSelectedImage(null)}>×</button>
            <img src={selectedImage} alt="Enlarged product" className="enlarged-img" onError={(e) => {
              e.target.src = '/vac.jpg'; // fallback
            }} />
          </div>
        </div>
      )}
    </div>
  );
}

export default Products;
